import RelatorioEmDesenvolvimento from "../../../components/RelatorioEmDesenvolvimento";

const InsightsAuto = () => (
  <RelatorioEmDesenvolvimento
    titulo="Insights Automáticos"
    descricao="Vai depender de um modelo de análise treinado com histórico real da fazenda."
  />
);

export default InsightsAuto;
